import { render, staticRenderFns } from "./ReviewAppDialog.vue?vue&type=template&id=11969f2f&scoped=true"
import script from "./ReviewAppDialog.vue?vue&type=script&lang=js"
export * from "./ReviewAppDialog.vue?vue&type=script&lang=js"
import style0 from "./ReviewAppDialog.vue?vue&type=style&index=0&id=11969f2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11969f2f",
  null
  
)

export default component.exports